<template>
  <div class="invite_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{$t('user.inviteFriends')}}</div>
    </div>
    <div class="wp">
      <div class="m-invitel">
        <!-- 邀请链接 -->
        <div class="item">
          <div class="g-boxl">
            <div class="tit">Invitation Link Address</div>
            <div class="u-row" style="align-items: center; justify-content: flex-start;">
              <!-- 左边链接 -->
              <div class="u-col u-col-7" style="flex: 0 0 58.3333%;">
                <div class="txt" style="overflow-wrap: break-word; word-break: break-all;">
                  {{ data.share_link }}
                </div>
              </div>
              <!-- 右边二维码 -->
              <div class="u-col u-col-5" style="flex: 0 0 41.6667%;">
                <div class="centerItem" style="width: 100%; height: 100px; margin-top: -25px;">
                  <div class="u-image" style="width: 90px; height: 90px; border-radius: 4px; margin-top: 10px;">
                    <canvas ref="qrcodeCanvas"></canvas>
                  </div>
                </div>
              </div>
            </div>
            <!-- 按钮区域 -->
<!--            <div style="display: flex; flex-wrap: nowrap; margin-top:10px;">-->
<!--              <a href="javascript:void(0)" class="btn" v-clipboard="() => data.share_link " v-clipboard:success="copy" v-clipboard:error="clipboardErrorHandler">Copy Link</a>-->
<!--            </div>-->
            <!-- 触发按钮 -->
            <div class="basic_btn mt-20" @click="showShare = true">{{$t('Share')}}</div>
          </div>
        </div>

        <!-- Notice 部分 -->
        <div class="item">
          <div class="g-boxl sty2">
            <div class="tips">{{rule.title}}</div>
            <div class="desc" v-html="rule.content"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 分享面板 -->
    <van-share-sheet
            v-model="showShare"
            :title="$t('Share with your friends')"
            :options="options"
            @select="onSelect"
            :cancel-text="$t('Cancel')"
    />
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Empty} from 'vant';
import Clipboard from "v-clipboard";
import QRCode from 'qrcode'

Vue.use(Empty).use(Clipboard);
export default {
  name: "share",
  data() {
    return {
      lang: 'en_us',
      data: {
        reward: [],
        share_user: []
      },
      tgData: {},
      cutNow: 1,
      cutShow: true,
      qrcode: false,
      tgDataShow: false,
      shareUserDate: false,
      showShare: false,
      shareUrl: "", // 分享链接
      shareText: "", // 分享信息
      options: [
        { name: "Twitter",  icon: require("@/assets/images/twitter.png"), platform: "twitter" },
        { name: "Facebook", icon: require("@/assets/images/facebook.png"), platform: "facebook" },
        { name: "LinkedIn", icon: require("@/assets/images/linkedin.png"), platform: "linkedin" },
        { name: "Telegram", icon: require("@/assets/images/telegram.png"), platform: "telegram" },
        { name: "WhatsApp", icon: require("@/assets/images/whatsapp.png"), platform: "whatsapp" },
        { name: "Copy link", icon: 'link', platform: "copy" },
      ],
      rule: {}, // 规则
    };
  },
  created() {
    this.lang = localStorage.getItem("lang")||"en_us";
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    onSelect(option) {
      const encodedUrl = encodeURIComponent(this.shareUrl);
      const encodedText = encodeURIComponent(this.shareText);

      // 定义 APP Scheme 和 Web 链接
      let appUrl = "";
      let webUrl = "";

      switch (option.platform) {
        case "twitter":
          appUrl = `twitter://post?message=${encodedText}%20${encodedUrl}`;
          webUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
          break;

        case "facebook":
          appUrl = `fb://facewebmodal/f?href=${encodedUrl}`;
          webUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
          break;

        case "linkedin":
          // LinkedIn 没有公开的 APP Scheme，直接用网页分享
          webUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
          break;

        case "telegram":
          appUrl = `tg://msg?text=${encodedText}%20${encodedUrl}`;
          webUrl = `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`;
          break;

        case "whatsapp":
          appUrl = `whatsapp://send?text=${encodedText}%20${encodedUrl}`;
          webUrl = `https://api.whatsapp.com/send?text=${encodedText}%20${encodedUrl}`;
          break;

        case "copy":
          this.copyShare(this.shareUrl);
          this.showShare = false;
          return;
      }

      if (appUrl) {
        // 优先尝试打开 APP
        window.location.href = appUrl;
        // 兜底逻辑：如果 1 秒内没反应，则跳转网页版
        setTimeout(() => {
          if (webUrl) {
            window.open(webUrl, "_blank", "width=600,height=500");
          }
        }, 1000);
      } else if (webUrl) {
        // 直接走网页分享
        window.open(webUrl, "_blank", "width=600,height=500");
      }

      this.showShare = false; // 关闭分享面板
    },
    copyShare(value) {
      const input = document.createElement("input");
      input.value = value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$toast({
        background: "#07c160",
        message: this.$t("invest_qrcode.copySucceeded"),
      });
    },
    cutShare(idx) {
      if (idx == 1) {
        this.cutNow = 1;
        this.cutShow = true;
      } else {
        this.cutNow = 2;
        this.cutShow = false;
      }
    },
    start() {
      Fetch('/user/share').then((r) => {
        this.data = r.data;
        this.rule = r.data.rule;
        this.shareUrl = this.data.share_link;
        this.generateQRCode(this.data.share_link);
        if (r.data.share_user.length == 0) {
          this.shareUserDate = true;
        } else {
          this.shareUserDate = false;
        }
      });
      Fetch('/user/funds', {
        reason_id: 10,
      }).then((r) => {
        this.tgData = r.data;
        if (r.data.list.length == 0) {
          this.tgDataShow = true;
        } else {
          this.tgDataShow = false;
        }
      });
    },
    generateQRCode(text) {
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, text, {
        width: 90,
        margin: 2
      }, (error) => {
        if (error) console.error(error);
        else console.log('QR code generated successfully!');
      });
    },
    downLoad() {
      this.downloadIamge(this.data.share_image_url, 'share.jpg')
    },
    downloadIamge(imgsrc, name) { //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    copy({ value, event }){
      var input = document.createElement("input"); // 创建input对象
      input.value = value; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$toast({
        background: "#07c160",
        message: this.$t("invest_qrcode.copySucceeded"),
      });
    },
    clipboardErrorHandler ({ value, event }) {
      console.log('error', value)
    },
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-empty {
  padding: 0 0 20px 0;
}

.back_left {
  background: url(../../views/images/item/back_b.png) no-repeat center center;
}
.big_tit{
  color: #000000;
}
.wp {
  display: block;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.wp {
  padding: 0 15px;
  margin-top: 20px;
}
.m-invitel {
  overflow: hidden;
}
.m-invitel .item {
  overflow: hidden;
}
.g-boxl {
  overflow: hidden;
  background: #fff;
  padding: 15px 15px;
  margin-bottom: 15px;
  border: 1px solid #76b900;
  border-radius: 5px;
}
.m-invitel .item .g-boxl {
  padding: 15px 13px;
}
.m-invitel .item .tit {
  font-size: 17px;
  color: #000;
  font-weight: 700;
  line-height: 1.5em;
  overflow: hidden;
  margin-bottom: 12px;
}
.u-row {
  display: flex;
  flex-direction: row;
}
.u-col {
  padding: 0;
  box-sizing: border-box;
}
.u-col-7 {
  width: calc(100% / 12 * 7);
}
.m-invitel .item .txt {
  font-size: 14px;
  color: #000;
  line-height: 1.5em;
  overflow: hidden;
  padding-bottom: 4px;
  border-bottom: 1px dashed rgba(145, 154, 178, .4);
}
.u-col-5[data-v-91d5fe04] {
  width: calc(100% / 12 * 5);
}
.centerItem {
  display: flex;
  flex: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.m-invitel .item .btn {
  overflow: hidden;
  display: block;
  width: 180px;
  height: 35px;
  line-height: 33px;
  text-align: center;
  background: #76b900;
  font-size: 15px;
  color: #000;
  margin: 14px auto 5px;
  border-radius: 5px;
}
.m-invitel .item .tips {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2em;
  overflow: hidden;
  color: #000;
  margin-bottom: 10px;
}
.m-invitel .item .desc {
  font-size: 13px;
  line-height: 1.538em;
  color: #000;
  overflow: hidden;
}
.m-invitel .item .desc .p {
  margin-bottom: 11px;
}
.clipboard {
  margin: 30px 20px 30px 20px;
  background-color: #be0503;
  color: #ffffff;
  border-radius: 20px;
  padding: 7px 30px;
  text-align: center;
  font-size: 14px;
}
</style>
